import { post } from './request'

export function projectAdd(data) {
  return post('/api/Project/Add', data)
}

export function projectUpdate(data) {
  return post('/api/Project/Update', data)
}

export function projectList(data) {
  return post('/api/Project/List', data)
}

export function projectDetail(data) {
  return post('/api/Project/Detail', data)
}

export function projectDelete(data) {
  return post('/api/Project/Delete', data)
}
